export default {
    error: {
        mimetype: 'Please choose a suitable file type (JPG/PNG/GIF)',
        required: 'Please choose an image',
        size: 'Please select images that do not exceed 8MB in size.'
    }
}
